import axios from 'axios';
import apisUrls from '../urls';

const deleteClientApi = (values) => {
  return axios.post(apisUrls?.deleteClient, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default deleteClientApi;
